import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';

interface Props {
  text?: string;
}

const TextContainer = styled.div<Props>`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  .modal-title {
    width: calc(100% - 96px);
    display: block;
    font-family: 'Nimbus Sans Bold';
    color: ${tokens.ColorGrey900};
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.5px;
    padding: 0 0 32px;
    margin: 0 auto 32px;
    border-bottom: 1px solid ${tokens.ColorWhite100};

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 26px;
      padding: 24px 96px 24px 16px;
      margin: 0 auto 24px;
    }
  }

  .modal-copy {
    padding: 0 48px 56px;
    display: block;

    @media (max-width: 767px) {
      padding: 0 16px;
    }
  }
`;

class RichTextContainer extends Component<Props> {
  render(): JSX.Element {
    const { text } = this.props;
    return <TextContainer dangerouslySetInnerHTML={{ __html: text || '' }} />;
  }
}

export default RichTextContainer;
